import { Component, Input } from '@angular/core';

import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  selector: 'entity-transaction-profile-client',
  templateUrl: './entity-transaction-profile-client.component.html'
})

export class EntityTransactionProfileClientComponent {
  @Input() entityIdDetails: EntityIdDetails;
  entityType = 'Client';

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/entitytransactionprofileclient/entity-transaction-profile-client.component.ts